// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e6b6edeb","703":"e80d501c"}[chunkId] + ".chunk.js";
};